import styled from 'styled-components';
import Theme from '../../../styles/models/theme';
import Icon from '../Icon';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  max-width: 100%;
`;

export const IconComp = styled(Icon)`
  padding-top: 13px;
  padding-right: 5px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RemittanceText = styled.h1<{
  theme?: Theme;
  isCurrentUser?: boolean;
}>`
  color: ${({theme, isCurrentUser}) =>
    isCurrentUser ? theme.darkText : theme.darkText};
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  margin-bottom: 0;
`;

export const LinkText = styled.h1<{
  theme?: Theme;
  isCurrentUser?: boolean;
}>`
  color: ${({theme, isCurrentUser}) =>
    isCurrentUser ? theme.darkText : theme.darkText};
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 16px;
  align-self: flex-end;
`;
